import React from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import WaterDropRoundedIcon from '@mui/icons-material/WaterDropRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import './AlertNotification.css';

export default function AlertNotification({ 
  type, 
  title, 
  message, 
  timestamp, 
  isNew, 
  isExample, 
  isRead = false, 
  onMarkAsRead,
  alertId 
}) {
  const getIcon = () => {
    switch (type) {
      case 'warning':
        return <WarningAmberRoundedIcon className="alert-icon warning" />;
      case 'info':
        return <InfoRoundedIcon className="alert-icon info" />;
      case 'water':
        return <WaterDropRoundedIcon className="alert-icon water" />;
      case 'time':
        return <ScheduleRoundedIcon className="alert-icon time" />;
      default:
        return <InfoRoundedIcon className="alert-icon info" />;
    }
  };

  const getAlertClasses = () => {
    let classes = `alert-notification ${type}`;
    if (isNew) classes += ' new-alert';
    if (isExample) classes += ' example-alert';
    if (isRead) classes += ' read-alert';
    return classes;
  };

  const handleMarkAsRead = () => {
    if (onMarkAsRead && alertId) {
      onMarkAsRead(alertId);
    }
  };

  return (
    <div className={getAlertClasses()}>
      <div className="alert-header">
        {getIcon()}
        <h3>
          {isNew && !isRead && <span className="new-badge">Nueva</span>}
          {isExample && <span className="example-badge">Ejemplo</span>}
          {isRead && <span className="read-badge">Leída</span>}
          {title}
        </h3>
        {timestamp && <span className="alert-timestamp">{timestamp}</span>}
      </div>
      <p className="alert-message">{message}</p>
      {!isExample && !isRead && onMarkAsRead && (
        <div className="alert-actions">
          <button 
            className="mark-read-btn"
            onClick={handleMarkAsRead}
            title="Marcar como leída"
          >
            <VisibilityRoundedIcon /> Marcar como leída
          </button>
        </div>
      )}
    </div>
  );
}
